module.exports = __webpack_public_path__ + "src/assets/img/light_front.a92d9530.svg";